<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">服务费用</div>
            <div class="colorright"></div>
        </div>
        <div class="cball">
            <div v-if="tabindex == 5" class="bg-white" style="padding: 40px;min-height: 480px;">
                <div class="pointer" v-for="(item,index) in flist" :key="index" @click="tonewdetail(item.id)" style="margin-bottom: 20px;">
                    <el-row style="border: 1px solid #eee;padding: 0 10px;border-radius: 8px;">
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                收费名称: {{item.title ? item.title : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                签约时间: {{item.sign_time ? item.sign_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                签约时长: {{item.lease_time ? item.lease_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                签约到期时间: {{item.sign_expire ? item.sign_expire : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                收费价格: {{item.price ? item.price : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                收费方式: {{item.pay_way ? item.pay_way : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-cut newone">
                                费用到期时间: {{item.expire_time ? item.expire_time : '--'}}
                            </div>
                        </el-col>
                        <el-col class="text-left" :span="6">
                            <div class="text-center flex ">
                                <div style="width: 100px;color: #fff;font-size: 16px;height: 40px;line-height: 40px;border-radius: 6px;background-color: #00c9bd;">查看详情</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="" v-if="!flist.length && !load">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="text-center" style="padding-top: 40px;">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :pager-count="pagerCount"
                        :hide-on-single-page="true"
                        
                        :page-size="pagef"
                        @size-change="handleSizeChangetwo"
                        @current-change="handleCurrentChangetwo"
                        :current-page="currentPagetwo"
                        :total="totalnumtwo"
                        >
                        </el-pagination>
                </div>
            </div>




            <div v-if="tabindex == 7" class="bg-white" style="padding: 40px;min-height: 480px;position: relative;">
                        <div @click="backone" class="backbtn">返回</div>
                        <div class="flex justify-between flex-wrap" style="padding-top: 20px">
                            <div class="newclass pointer hvr-glow" v-for="(item,index) in newlist" :key="index">
                                <el-row class="rowone">
                                    <el-col class="text-right pleft" :span="6">缴费时间</el-col>
                                    <el-col class="text-left pright" :span="18">{{item.pay_time}}</el-col>
                                </el-row>
                                <el-row class="rowone">
                                    <el-col class="text-right pleft" :span="6">费用到期时间</el-col>
                                    <el-col class="text-left pright" :span="18">{{item.expire_time}}</el-col>
                                </el-row>
                                <el-row class="rowone">
                                    <el-col class="text-right pleft" :span="6">支付方式</el-col>
                                    <el-col class="text-left pright" :span="18">{{item.pay_way}}</el-col>
                                </el-row>
                                <el-row class="rowone">
                                    <el-col class="text-right pleft" :span="6">备注</el-col>
                                    <el-col class="text-left text-cut pright" :span="18">{{item.remark}}</el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="" v-if="!newlist.length && !load">
                           <el-empty description="暂无数据"></el-empty>
                        </div>
                        <div class="text-center" style="padding-top: 40px;">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                :pager-count="pagerCount"
                                :hide-on-single-page="true"
                                
                                :page-size="newpages"
                                @size-change="schange"
                                @current-change="curchange"
                                :current-page="currents"
                                :total="totals"
                                >
                                </el-pagination>
                        </div>
                    </div>
        </div>
        
    </div>
</template>
<script>
export default ({
    data() {
        return{
            config: '',
            tabindex: 5,
            flist: [],
            pagerCount: 7,
            pagef: 5,
            totalnumtwo: 0,
            currentPagetwo: 1,
            load: true,
            userinfo: '',

            totals: 0,
            currents: 1,
            newlist: [],
            newpages: 5,


            id: 0
        }
    },
    methods:{
        curchange(currentPage){
            this.currents = currentPage;
            this.tonewdetail();
        },
        schange(){

        },
        backone(){
            this.flist = [];
            this.currentPagetwo = 1;
            this.load = true;
            this.totalnumtwo = 0;
            this.getflist();
            this.tabindex = 5;
        },
        handleSizeChangetwo(){

        },
        handleCurrentChangetwo(currentPage){
            this.currentPagetwo = currentPage;
            this.getflist();
        },
        getconfig(){
            this.$api.index.config().then(res=>{
                this.config = res.data;
            })
        },
        getflist(){
            var data = {
                shop_id: this.userinfo.shop.id,
                start: this.currentPagetwo,
                page_size: this.pagef
            }
            this.$api.index.my_ortherroom(data).then(res=>{
                this.flist = res.data;
                this.totalnumtwo = res.count;
                this.load = false;
            }).catch(res=>{
                // console.log(res,1111111111)
                this.load = false;
            })
        },
        tonewdetail(id){
            this.id = id;
            var data = {
                id: this.id,
                start: this.currents,
                page_size: this.newpages,
                type: 1
            }
            this.tabindex = 7;
            this.$api.index.my_record(data).then(res=>{
                console.log(res)
                this.newlist = res.data;
                this.totals = res.count;
                this.load = false;
            }).catch(res=>{
                // console.log(res,1111111111)
                this.load = false;
            })
        },
    },
    created(){
        this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
        this.getconfig();
        this.getflist();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }
    .cball{
        border-radius: 0 0 12px 12px;overflow:hidden;
    }



    
    .newone{
        width: 90%;height: 50px;line-height: 50px;
    }

    
    .backbtn{
        width: 82px;
        height: 35px;
        line-height: 35px;
        background-color: #00c9bd;
        border-radius: 6px;
        color: #fff;font-size: 16px;
        position: absolute;
        top: 13px;left: 10px;
        text-align: center;
        cursor: pointer;z-index: 9999;
    }
    .rowone{
        height: 60px;line-height: 60px;
    }
    .pleft{
        color: #a0a0a0;font-size: 18px;
    }
    .pright{
        padding-left: 45px;
        color: #151515;font-size: 18px;
    }
    .newclass{
        width: 48%;border: 1px solid #eee;border-radius: 10px;
        
        /* box-shadow: 6px 6px 8px rgba(26, 26, 26, 0.2) */
    }
</style>


// WEBPACK FOOTER //
// service_price.vue?84a8b154